import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Sprint 2 L1 Correction 3 — persistent sandbox watermark.
 *
 * Non-dismissible in this preview. Reads sandbox_mode from /api/health.
 * Production launch flips SANDBOX_MODE=false → banner disappears.
 */
export default function SandboxBanner() {
  const [sandbox, setSandbox] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/health")
      .then((res) => { if (mounted) setSandbox(res.data.sandbox_mode === true); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!sandbox) return null;
  return (
    <div
      role="alert"
      data-testid="sandbox-banner"
      style={{
        background: "#fef3c7",
        borderBottom: "1px solid #f59e0b",
        color: "#78350f",
        padding: "8px 20px",
        fontSize: "12px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        position: "sticky",
        top: 0,
        zIndex: 60,
      }}
    >
      <AlertTriangle size={14} strokeWidth={2.5} />
      <span>
        DEMO — synthetic data, not legally verified. This environment is not for production use.
      </span>
    </div>
  );
}
